import { render, staticRenderFns } from "./HeaderConfig.vue?vue&type=template&id=36ead370&scoped=true"
import script from "./HeaderConfig.vue?vue&type=script&lang=js"
export * from "./HeaderConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ead370",
  null
  
)

export default component.exports